import { ApplicantInterface, FundAllocationValues, FundsAllowDetailsInterface, ScholarshipSummaryInterface } from "../../types/types";
import {
  ActionTypes,
  APPLICATION_MANAGE_INFO,
  FUND_ALLOWCATION,
  FUND_ALLOWCATION_DETAILS,
  SCHOLARSHIP_SUMMARY_DETAILS,
} from "../types";

export const addRowDataItem = (item: ApplicantInterface): ActionTypes => ({
  type: APPLICATION_MANAGE_INFO,
  payload: item,
});

export const addFundallowItem = (item: FundAllocationValues): ActionTypes => ({
  type: FUND_ALLOWCATION,
  payload: item,
});

export const addFundallowDetails = (item: FundsAllowDetailsInterface): ActionTypes => ({
  type: FUND_ALLOWCATION_DETAILS,
  payload: item,
});

export const addScholarshipSummaryItem = (item: ScholarshipSummaryInterface): ActionTypes => ({
  type: SCHOLARSHIP_SUMMARY_DETAILS,
  payload: item,
});